export default "__VITE_ASSET__8bca28ac__"